module.exports = __webpack_public_path__ + "static/media/tank-cover-light.feda45fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-cover-light.png
// module id = 1140
// module chunks = 0